// Vollbild-Hinweis statt Admin-Bereich: gesperrtes Konto, Portal noch nicht verfügbar
// oder Rolle ohne Oberfläche. Einzige Aktion: Abmelden.
import { useState } from 'react';
import { LockSimple, House, SignOut } from '@phosphor-icons/react';
import { supabase } from '../../lib/supabase/client';
import type { Zugang } from '../../lib/portal/zugang';

const TEXTE: Record<Exclude<Zugang, 'verwaltung' | 'hausmeister'>, { titel: string; text: string }> = {
  gesperrt: {
    titel: 'Zugang deaktiviert',
    text: 'Ihr Zugang wurde von der Verwaltung deaktiviert. Wenden Sie sich bei Fragen bitte an Immo Schwede.',
  },
  portal: {
    titel: 'Ihr Portal ist bald verfügbar',
    text: 'Ihr Zugang ist angelegt. Das Portal wird gerade eingerichtet – wir melden uns, sobald Sie es nutzen können.',
  },
  kein_zugang: {
    titel: 'Kein Zugang',
    text: 'Für Ihr Konto ist keine Oberfläche freigeschaltet. Wenden Sie sich bitte an Immo Schwede.',
  },
};

export default function ZugangHinweis({ art }: { art: Exclude<Zugang, 'verwaltung' | 'hausmeister'> }) {
  const [laeuft, setLaeuft] = useState(false);
  const { titel, text } = TEXTE[art];
  const Symbol = art === 'portal' ? House : LockSimple;

  const abmelden = async () => {
    setLaeuft(true);
    await supabase.auth.signOut();
  };

  return (
    <div data-theme="dark" className="immo-flaeche" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="immo-wand" />
      <main
        role="alert"
        style={{
          position: 'relative', width: '100%', maxWidth: 420, padding: 32, borderRadius: 26, textAlign: 'center',
          background: 'var(--glass-strong)', boxShadow: 'var(--glass-strong-sh)',
        }}
      >
        <div
          aria-hidden
          style={{
            width: 64, height: 64, margin: '0 auto 20px', borderRadius: 20, display: 'flex', alignItems: 'center',
            justifyContent: 'center', background: 'var(--acc-fill)', color: 'var(--acc-ink)', boxShadow: 'var(--acc-sh)',
          }}
        >
          <Symbol size={30} weight="fill" />
        </div>
        <h1 style={{ margin: '0 0 10px', fontSize: 22, fontWeight: 800, color: 'var(--ink)' }}>{titel}</h1>
        <p style={{ margin: '0 0 28px', fontSize: 15, lineHeight: 1.5, color: 'var(--ink2)' }}>{text}</p>
        <button
          type="button"
          onClick={abmelden}
          disabled={laeuft}
          data-tip="Abmelden und zur Anmeldung zurückkehren"
          style={{
            width: '100%', minHeight: 48, border: 0, borderRadius: 14, display: 'flex', alignItems: 'center',
            justifyContent: 'center', gap: 10, fontSize: 15, fontWeight: 700, cursor: laeuft ? 'default' : 'pointer',
            background: 'var(--fill2)', color: 'var(--ink)', opacity: laeuft ? 0.6 : 1,
          }}
        >
          <SignOut size={20} />
          {laeuft ? 'Wird abgemeldet …' : 'Abmelden'}
        </button>
      </main>
    </div>
  );
}
